export type ApiClientError = {
  status: number;
  errorCode: string;
  message: string;
};

export function isApiClientError(value: unknown): value is ApiClientError {
  return (
    typeof value === "object" &&
    value !== null &&
    "status" in value &&
    "errorCode" in value &&
    "message" in value
  );
}

export function normalizeApiError(status: number, body: unknown): ApiClientError {
  const record = body && typeof body === "object" ? (body as Record<string, unknown>) : {};
  const errorCode =
    typeof record.errorCode === "string" && record.errorCode.length > 0
      ? record.errorCode
      : status === 401
        ? "Unauthorized"
        : status === 403
          ? "Forbidden"
          : status === 409
            ? "Conflict"
            : status === 422
              ? "ValidationError"
              : "HttpError";
  const message =
    typeof record.message === "string" && record.message.length > 0
      ? record.message
      : status === 401
        ? "Phiên đăng nhập không hợp lệ."
        : status === 403
          ? "Bạn không có quyền thực hiện thao tác này."
          : `Yêu cầu thất bại (${status}).`;

  return { status, errorCode, message };
}
